import React, { useState, useEffect } from "react";
import { Form, Switch, Checkbox, Button, Spin, message, Modal } from "antd";
import { connect } from "react-redux";
import {
  setBreakTypesList,
  setLeaveCategoryList,
  setRoleList,
} from "redux/actions";
import {
  getLocations,
  getClientid,
  getAllDepartmentList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { CALL_API } from "common/API";
import {
  STATUS_CODE,
  VALIDATE_CHARACTER,
  VALIDATE_SYMBOL_CHARACTER,
} from "common/Constants";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import { getEditLeaveJson } from "JsonFormat/EditLeaveJson";
import FormModal from "./FormModal";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import styled from "styled-components";
import { LoadingOutlined } from '@ant-design/icons';

const EditLeaves = ({
  isModalVisible,
  closeModal,
  ClientId,
  getLeaveList,
  LeaveDetails,
  saveLeaveCategoryList,
  departmentList,
  locationList,
  viewOnly,
  saveRoleList,
  deletedLeave,
  canDelete,
  deleteLoading,
}) => {
  const [form] = Form.useForm();

  const fetchMasterData = async (fetch_master_data) => {
    const { code, leaveCategories, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveLeaveCategoryList(leaveCategories);
      saveRoleList(roleList);
    }
  };

  const [data, setData] = useState({});
  useEffect(() => {
    setData({
      leaveCategoryId: LeaveDetails.leaveCategoryId,
      leaveCategoryName: LeaveDetails.leaveCategoryName,
      numberOfLeaves: LeaveDetails.numberOfLeaves,
      eligible: LeaveDetails.eligible,
      holiday: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
      isSaturday: LeaveDetails?.isSaturday,
    });
  }, [LeaveDetails]);

  const { EditLeaveForm } = getEditLeaveJson(data);
  const [submit, setsubmit] = useState(false);
  const [create, setCreate] = useState(false);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllDepartmentsChecked, setSelectAllDepartmentsChecked] =
    useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);

  useEffect(() => {
    form.setFieldsValue({
      leave_category_name: LeaveDetails.leaveCategoryName,
      numberofLeaves: LeaveDetails.numberOfLeaves,
      description: LeaveDetails.description,
      holidays: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
      isSaturday: LeaveDetails?.isSaturday,
    });
    setSelectedLocationId(LeaveDetails.locationId);
    setSelectDepartmentId(LeaveDetails.departmentId);
  }, [LeaveDetails]);

  useEffect(() => {
    setSelectAllDepartmentsChecked(
      selectDepartmentId?.length === departmentList?.length
    );
    setSelectAllLocationChecked(
      selectedLocationId?.length === locationList?.length
    );
  }, [selectDepartmentId, departmentList, selectedLocationId, locationList]);

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    setsubmit(true);
  };

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        const check = selectDepartmentId?.includes(department_id)
          ? true
          : false;
        return (
          <Switch
            checked={check}
            size="small"
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
    setsubmit(true);
  };

  const handleSelectAllDepartmentsChange = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentsChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
    setsubmit(true);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "country",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
    setsubmit(true);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e.target.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = locationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
    setsubmit(true);
  };

  // useEffect(() => {
  //   if (submit) {
  //     onFinish();
  //   }
  // }, [selectDepartmentId, selectedLocationId, data]);

  const showExceededConfirmation = (response) =>
    new Promise((resolve) => {
      const exceededUsers = response?.exceededUsers || [];
      Modal.confirm({
        title: "Leave already used exceeds the new allocation",
        width: 520,
        content: (
          <div>
            <p>
              {response?.message}. If you continue, these users will have a
              negative balance for this leave.
            </p>
            <ul className="mb-0" style={{ maxHeight: 200, overflowY: "auto" }}>
              {exceededUsers.map((user) => (
                <li key={user.userid}>
                  {user.userid} - {user.usedLeaves} day(s) used
                </li>
              ))}
            </ul>
          </div>
        ),
        okText: "Update Anyway",
        cancelText: "Cancel",
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

  const onFinish = async (confirmed = false) => {
    setCreate(true);
    const {
      leaveCategoryId,
      leaveCategoryName,
      numberOfLeaves,
      eligible,
      holiday,
      weekend,
      isSaturday,
    } = data;
    const containsSpecialCharacters = !VALIDATE_SYMBOL_CHARACTER.test(leaveCategoryName);
    if (containsSpecialCharacters) {
      message.error("Leave category name contains invalid characters. Please remove special symbols or numbers");
      setCreate(false);
      return false;
    }
    const updateResponse = await CALL_API(
      `owner-leave/${ClientId}/${leaveCategoryId}`,
      "patch",
      {
        leavecategoryname: leaveCategoryName,
        numberofleaves: numberOfLeaves,
        department: selectDepartmentId,
        location: selectedLocationId,
        eligible: eligible,
        holiday: holiday,
        weekend: weekend,
        isSaturday: isSaturday,
        confirmed,
      }
    );
    const { code } = updateResponse || {};

    // Some users have already used more than the new number of days
    // (only returned for clients other than MAIN_CLIENT_ID)
    if (updateResponse?.requiresConfirmation) {
      setCreate(false);
      const proceed = await showExceededConfirmation(updateResponse);
      if (proceed) {
        await onFinish(true);
      }
      return;
    }

    if (code === STATUS_CODE.SUCCESS) {
      const oldLocations = LeaveDetails.locationId || [];
      const newLocations = selectedLocationId || [];
      const newlyAddedLocations = newLocations?.filter(loc => !oldLocations.includes(loc));
      if (newlyAddedLocations.length === 0) {
        console.warn("No new locations added. Only updating category details.");
      } else {
        const secondPayload = {
          clientId: ClientId,
          leavecategoryId: leaveCategoryId,
          NewlocationId: selectedLocationId,
          numberofleaves: numberOfLeaves,
          OldlocationId: oldLocations,
          gender: eligible
        };

        const secondResponse = await CALL_API(
          `owner-leave/${ClientId}?updateleaveallocation=true`,
          "post",
          secondPayload
        );
        if (secondResponse.code === STATUS_CODE.SUCCESS) {
          message.success("Leave updated and allocation recalculated successfully");
        } else {
          // message.warning("Leave updated, but allocation update failed");
        }
      }
      // ---------------------------
      // Second API Call (POST)
      // ---------------------------

      closeModal();



      setCreate(false);
      fetchMasterData();
      getLeaveList();
      message.success("Leave has been updated successfully");
    } else {
      setCreate(false);
    }
  };
  // onFinish closes the page itself once the update succeeds, so the page
  // stays open while the confirmation dialog is shown
  const handleSave = async () => {
    await onFinish();
  };

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <div className="styled-card">
          <GridBuilder
            formStructureJson={EditLeaveForm}
            handleChange={handleFormChange}
            initialValues={LeaveDetails}
          />
        </div>
      ),
    },
    // {
    //   id: 2,
    //   label: "Department",
    //   component: (
    //     <>
    //       {!viewOnly && (
    //         <div className="mb-3 d-flex justify-content-between">
    //           {departmentList?.length > 0 && (
    //             <Checkbox
    //               className=""
    //               checked={selectAllDepartmentsChecked}
    //               onChange={handleSelectAllDepartmentsChange}
    //             >
    //               Select All
    //             </Checkbox>
    //           )}
    //         </div>
    //       )}
    //       <EditSelectTable
    //         columns={departmentcolumns}
    //         tabledata={departmentList}
    //         setOpenModal={() => setOpenDepartmentModal(true)}
    //         Name="Add Department"
    //       />
    //       <FormModal
    //         isModalVisible={openDepartmentModal}
    //         closeModal={() => setOpenDepartmentModal(false)}
    //         Name="Department"
    //       />
    //     </>
    //   ),
    // },
    {
      id: 3,
      label: "Country",
      component: (
        <>
          <div className="mb-3 d-flex justify-content-between">
            {locationList?.length > 0 && (
              <Checkbox
                className=""
                checked={selectAllLocationChecked}
                onChange={handleSelectAllLocationChange}
              >
                Select All
              </Checkbox>
            )}
          </div>

          <EditSelectTable
            columns={locatincolumns}
            tabledata={locationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      ),
    },
  ];

  return (
    <>
      {isModalVisible && (
        <>
          <LeaveStyle>
            <div className="d-flex justify-content-between">
              <div className="leave_header_content">
                <label
                  className="bg-transparent border-0 mb-3 text-left styled-cursor"
                  onClick={() => {
                    closeModal(false);
                  }}
                >
                  Leave
                  <ArrowForwardIosIcon className="px-1" />
                </label>{" "}
                <b className=" pb-0 pt-1">{data.leaveCategoryName}</b>
              </div>
              <div className="location_header_action">
                {canDelete && (
                  <Button
                    type="primary"
                    danger
                    className="me-2"
                    onClick={deletedLeave}
                    loading={deleteLoading}
                  >
                    Delete
                  </Button>
                )}
                {!viewOnly && (
                <Button type="primary" onClick={handleSave}>{create && <Spin indicator={<LoadingOutlined spin />} />}Save</Button>
                )}
              </div>
            </div>
          </LeaveStyle>

          <TabsList items={items} form={form} />
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBreakTypes: setBreakTypesList,
      saveLeaveCategoryList: setLeaveCategoryList,
      saveRoleList: setRoleList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps, null)(EditLeaves);

const LeaveStyle = styled.div`
  .leave_header_content{
    width: max-content;
  }
  .leave_header_action{
    width: 20px;
    height: 20px;
    width: max-content;
  }
  .ant-btn-primary.delete-btn {
    background-color: #ff4d4f !important;
    border-color: #ff4d4f;
    color: #ffffff !important;
  }
`;